import { OrganizationApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { changeSelectedMembers } from '../../../store/slices/add-edit-policy.slice';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';

const useHttpChangeAffectedMembers = () => {
    const { t } = useTranslation('newNotifications');
    const navigate = useNavigate();
    const toastHandler = useContainer(ToastStateHandler);
    const organizationApi = useContainer(OrganizationApi);

    const exec = (id: string, ids: string[]) => {
        const { exec, abort } = organizationApi.changeAffectedMembers({
            params: { id },
            body: { ids },
            onSuccess: _ => {
                dispatch(changeSelectedMembers());
                toastHandler.push('success', t('policy.updateTitle'), t('clients.updateSuccess'));
            },
            onError: () => {
                navigate('/organization/policies');
                toastHandler.push('error', t('policy.updateTitle'), t('policy.updateError'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpChangeAffectedMembers;
